import { required, optional, obj, array } from 'AppReact/schema';

const tenant = {
  full_name: required('string'),
  id: required('integer'),
};

const lease = {
  actual_move_in: optional('jsDate'),
  actual_move_out: optional('jsDate'),
  expected_move_out: optional('jsDate'),
  id: required('integer'),
  start_date: required('jsDate'),
  tenants: array(obj(tenant))
}

export const unit = {
  area: optional('integer'),
  current_lease: array(obj(lease)),
  floor_plan: optional('string'),
  future_leases: array(obj(lease)),
  past_leases: array(obj(lease)),
  leases: array(obj(lease)),
  id: required('integer'),
  number: required('string'),
  status: required('string'),
  open_work_orders: required('integer'),
  total_work_orders: required('integer'),
}